export default __webpack_public_path__ + "static/media/viesti.88c740af.svg";